<template>
  <v-flex xs10 offset-xs1 v-if="workStockItem">
    <div class='fl hf mb-5'>
      <div class='golden-left'>
        <h1 class='mb-3'>
          {{ 'work-stock.details.title' | translate }} #{{ workStockItem.id}}
        </h1>
        <p>{{ 'work-stock.details.text' | translate }}</p>
      </div>

      <div class='golden-right'>
        <card-button
          v-if="workStockItem.status === states.New"
          first='Ik wil dit item'
          main='in behandeling'
          second='nemen'
          :disabled="isCurrentlyProcessing"
          @click="handleStartReview()"
        />
        <card-button darkGray
          v-if="workStockItem.status === states.Reviewing"
          first='Ik wil dit item'
          main='vrijgeven'
          second='en niet meer behandelen'
          @click='endReview(workStockItem)'
        />
      </div>
    </div>

    <div class='fl hf'>
      <div class='golden-left'>
        <div class='closed-comment mb-5 fl' v-if="workStockItem.status === states.Closed && workStockItem.comment != null && workStockItem.comment !== ''">
          <judge-mace class='judge-mace' />
          <div>
            <h6>Beoordeling</h6>
            <p>{{ workStockItem.comment }}</p>
          </div>
        </div>

        <work-stock-item-new-report-of-sickness :serializedData="workStockItem.data"
          v-if="workStockItem.workStockType === 'ReportOfSickness' && workStockItem.action === 'REGISTER'"
          class='mb-5'
        />

        <work-stock-item-update-report-of-sickness :serializedData="workStockItem.data"
          v-if="workStockItem.workStockType === 'ReportOfSickness' && workStockItem.action === 'UPDATE'"
          class='mb-5'
        />

        <work-stock-item-new-uwv-decision :serializedData="workStockItem.data"
          v-if="workStockItem.workStockType === 'UwvDecision' && workStockItem.action === 'REGISTER'"
          class='mb-5'
        />

        <div class='comment-box' v-if="workStockItem.status === states.Reviewing">
          <div>
            <div class='fl hf'>
              <judge-mace class='judge-mace' />
              <div>
                <h6>Beoordeling van Item</h6>
                <p>Jouw notities kun je hieronder kwijt</p>
              </div>
            </div>

            <textarea rows='4' cols='250' maxlength='1024'
              class='comment-input hf'
              placeholder='Vul hier het commentaar in.'
              v-model="comment"/>

            <div style='float: right' class='mt-4'>
              <Button error
                :disabled="isCurrentlyProcessing"
                :hoverErrors="evaluationHoverErrors"
                @click="reject({ item: workStockItem, comment: `[Geweigerd] ${comment != null ? comment : ''}` })" class='mr-3'
              >
                Ik wil het item Weigeren
              </Button>
              <Button positive
                :disabled="isCurrentlyProcessing"
                :hoverErrors="evaluationHoverErrors"
                @click="accept({ item: workStockItem, comment: `[Goedgekeurd] ${comment != null ? comment : ''}` })"
              >
                Ik wil het item Accepteren
              </Button>
            </div>
            <div style='clear: both' />
          </div>
        </div>
      </div>
      <div class='golden-right'>
        <work-stock-item-summary :workStockItem="workStockItem" class='mb-4' />
      </div>
    </div>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from '@/shared/constants/modal';
import CardButton from '@aevitae/aevitaeui/0_atoms/buttons/CardButton.vue';
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

import WorkStockItemSummary from '@/views/components/work-stock-details/WorkStockItemSummary.vue';

import WorkStockItemNewReportOfSickness from '@/views/components/work-stock-details/WorkStockItemNewReportOfSickness.vue';
import WorkStockItemUpdateReportOfSickness from '@/views/components/work-stock-details/WorkStockItemUpdateReportOfSickness.vue';
import WorkStockItemNewUwvDecision from '@/views/components/work-stock-details/WorkStockItemNewUwvDecision.vue';

import { WorkStockItemStates } from '@/resources/models/work-stock-item';

import WorkStock from '@/resources/constants/work-stock';
import JudgeMace from '@aevitae/aevitaeui/0_atoms/icons/JudgeMace.vue';

export default {
  name: 'WorkStockDetails',
  components: {
    CardButton,
    Button,
    JudgeMace,

    WorkStockItemSummary,
    WorkStockItemNewReportOfSickness,
    WorkStockItemUpdateReportOfSickness,
    WorkStockItemNewUwvDecision
  },
  props: {
    id: Number
  },
  data () {
    return {
      states: WorkStockItemStates,
      comment: ''
    };
  },
  methods: {
    ...mapActions({
      startReview: WorkStock.Actions.StartReview.START,
      endReview: WorkStock.Actions.EndReview.START,
      accept: WorkStock.Actions.Accept.START,
      reject: WorkStock.Actions.Reject.START
    }),

    handleStartReview () {
      if (this.isCurrentlyProcessing) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Error',
          title: this.$t('work-stock.modals.item-current-processing-start-review-title'),
          text: this.$t('work-stock.modals.item-current-processing-start-review-text')
        });
      } else {
        this.startReview(this.workStockItem);
      }
    }
  },
  computed: {
    isCurrentlyProcessing () {
      return this.$store.getters.isCurrentlyProcessing;
    },
    evaluationHoverErrors () {
      if (this.isCurrentlyProcessing) {
        return [this.$t('work-stock.modals.item-current-processing-judge-item-text')];
      } else return null;
    },
    workStockItem () {
      return this.$store.getters.workStock
        .find(w => w.id === this.id);
    }
  },
  watch: {
    workStockItem: function (newWorkStockItem, oldWorkStockItem) {
      if (newWorkStockItem != null) {
        this.comment = newWorkStockItem.comment;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.release-item {
  border-radius: $border-radius;
  background-color: $gray-lighten-4;
  color: $primary-lighten-1;
  padding: $base-padding;

  span {
    color: $primary;
    font-weight: 700;
  }
}

.closed-comment {
  border-radius: $border-radius;
  background-color: #464e63;
  padding: 20px 26px 23px 26px;
  align-items: flex-start;
  position: relative;
  overflow: hidden;

  h6 {
    color: white;
  }
  p {
    color: $primary-lighten-3;

    top: 3px;
    z-index: 2 !important;
  }

  .judge-mace {
    width: 48px;
    height: 42px;
    position: relative;
    top: 5px;
    fill: #d0d9ee;
    margin-right: 20px;
    border-radius: 5px;
    background-color: #4d566e;
    padding: 8px;
    box-shadow: 1px 1px 1px rgba(48, 55, 79, 0.52), inset 1px 1px 0px rgba(121, 128, 155, 0.22);
  }
}

.comment-box {
  background-color: #464e63;
  border-radius: $border-radius;
  padding: 21px 23px 23px 23px;
  width: 100%;

  h6 {
    color: white;
  }

  p {
    color: $primary-lighten-2;
    margin-bottom: 20px;
  }

  textarea {
    background-color: $primary-lighten-1;
    background-color: #535b74;
    background-color: #30374f;

    border-radius: $border-radius;

    color: $primary-lighten-2;
    padding: 20px;

    &::placeholder {
      color: $primary-lighten-1;
    }
  }

  .judge-mace {
    width: 48px;
    height: 42px;
    position: relative;
    top: 5px;
    fill: #d0d9ee;
    margin-right: 20px;
    border-radius: 5px;
    background-color: #4d566e;
    padding: 8px;
    box-shadow: 1px 1px 1px rgba(48, 55, 79, 0.52), inset 1px 1px 0px rgba(121, 128, 155, 0.22);
  }

  .comment-container {
    background-color: white;
    color: black;
  }
}

.confirmation-table {
  tr {
    &:first-child {
      td {
        border-top: 0;
        padding-top: 0;
      }
    }
    &:last-child {
      td {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}

.confirmation-table-adjust-padding {
  td {
    &:first-child {
      padding-left: 14px;
    }
    &:last-child {
      padding-right: 14px;
    }
  }
}

</style>
